// Copyright (c) 2016 Deere & Company

import StatusChangeRequestForm, {getDefaultState} from '../state/status-change-request-form';
import actions from '../../actions-list';

const updateStatusChangeRequestForm = (state, action) =>
    StatusChangeRequestForm.update(state, {
        isValid: {
            $set: action.data
        }
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_STATUS_CHANGE_REQUEST_FORM]: updateStatusChangeRequestForm
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/status-change-request/reducers/status-change-request-form.js